import React from 'react';
import { Redirect } from 'react-router';

export const LoginRedirect = () => { 
    return <Redirect to="/login"/>;
};